import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '@app/core/guards/auth.guard';
import { AppContainerComponent } from './app-container.component';
import { TagsComponent } from '@app/modules/taxonomy/tags/tags.component';
import { SearchesComponent } from '@app/modules/taxonomy/searches/searches.component';
import { AddArticleComponent } from '@app/shared/dialogs/add-article/add-article.component';
import { ChannelsComponent } from '../taxonomy/channels/channels.component';
import { AdminGuard } from '@app/core/guards/admin.guard';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: AppContainerComponent,
        children: [
            { path: '', redirectTo: 'search', pathMatch: 'full' },
            { path: 'channels', component: ChannelsComponent, canActivate: [AdminGuard] },
            {
                path: 'channel/:channelId',
                loadChildren: () => import('@app/modules/feed/feed.module').then((m) => m.FeedModule),
            },
            { path: 'tags', component: TagsComponent, canActivate: [AdminGuard] },
            { path: 'searches', component: SearchesComponent, canActivate: [AdminGuard] },
            { path: 'post/add', component: AddArticleComponent, canActivate: [AdminGuard] },
            {
                path: 'users',
                loadChildren: () =>
                    import('@app/modules/manage-users/manage-users.module').then((m) => m.ManageUsersModule),
                canActivate: [AdminGuard],
            },
            {
                path: 'search',
                loadChildren: () =>
                    import('@app/modules/search-page/search-page.module').then((m) => m.SearchPageModule),
                canActivate: [AdminGuard],
                runGuardsAndResolvers: 'always',
            },
            {
                path: 'admin',
                loadChildren: () => import('@app/modules/admin/admin.module').then((m) => m.AdminModule),
                canActivate: [AdminGuard],
                runGuardsAndResolvers: 'always',
            },
            {
                path: 'profile',
                loadChildren: () => import('@app/modules/profile/profile.module').then((m) => m.ProfileModule),
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AppContainerRoutingModule {}
